<template lang="html">

  <section class="popup-observaciones row-center">


    <div class="contenedor-popup-observaciones" :style="styles.backgroundWhite">

      <a class="cerrar -small" title="Salir" @click="cerrar">✕</a>

      <div class="contenedor-input -select" v-if="Object.values(dominios.motivoRechazoPracticas).length > 0 && config.action == 'rechazar'">
        <p v-html="$t('seleccione_motivo_rechazo')"></p>
        <select v-model="data.idMotivoRechazo" :style="styles.input_black" v-validate="'required'" name="motivorechazo">
          <option value="" v-html="$t('seleccione_motivo')">Selecciona un motivo</option>
          <option :value="key" v-for="(motivo,key) in dominios.motivoRechazoPracticas">{{motivo}}</option>
        </select>
        <span class='error' v-if="clicked">{{ errors.first('motivorechazo') }}</span>

      </div>

      <div class="contenedor-input">

        <template v-if="config.action == 'rechazar'">
            <p v-if="!!!brand.titulorechazo" v-html="$t('por_favor_indique_motivo')"></p>
            <p v-else v-html="brand.titulorechazo"></p>
        </template>

        <template v-if="config.action == 'validar'">
          <label for="">{{$t('observaciones')}}</label>
          <p>{{$t('incluir_observacion')}}</p>
        </template>

        <textarea focus="true" :style="styles.textarea" v-model="data.observacion" v-validate="(config.action == 'rechazar' ? 'required' : '' )" name="observacion"></textarea>
        <span class='error' v-if="clicked">{{ errors.first('observacion') }}</span>
        
        <div class="contenedor-input" v-if="brand.requestautorizacionPorCuatrimestre && config.action == 'validar'">
          <label for="">{{$t('autorizacion_cuatri')}}</label>
          <input :style="styles.input_black" type="text" v-model="data.autorizacionPorCuatrimestre" name="autorizacion">
        </div>

      </div>


      <div class="contenedor-input">

        <p v-if="Object.values(dominios.motivoRechazoPracticas).length == 0">{{$t('puede_adjuntar_documento')}}</p>

        <div class="dropzone row-start">

          <div class="text row-start">
            <span class="upload-icon-wrapper">
              <upload-icon v-if="!!!data.fichero.ficheroB64" class="tag-icon"></upload-icon>
              <success-icon v-else></success-icon>
            </span>
            <p v-if="!!!data.fichero.ficheroB64" :style="styles.colorMediumBlack">{{$t('arrastra')}}</p>
            <p v-else :style="styles.colorMediumBlack">{{nombreArchivo}}</p>
          </div>


          <input type="file" id="file" name="file" ref="file" @change="handleFileUpload($event)" v-validate="`size:20000000|mimes:${formatosPermitidos}`" :class="[{'has-error' : errors.has('file')}]"/>

          <span class='error'>{{ errors.first('file') }}</span>

        </div>

      </div>

      <a class="btn" :style="styles.solidPrimary" @click="finalizar" :loading="loading">{{$t('listo_terminar')}}</a>

    </div>


  </section>


</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  import uploadicon from '@/components/parts/icons/upload';
  import successicon from '@/components/parts/icons/success';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  export default  {
    name: 'observaciones',
    props: ['id','estado','config'],
    components : {
      'upload-icon' : uploadicon,
      'success-icon' : successicon
    },
    mounted (){
      this.setData();
    },
    data (){
      return {
        nombreArchivo : '',
        loading : false,
        data : {
          idPractica : '',
          idEstado : '',
          observacion : '',
          idMotivoRechazo  : '',
          autorizacionPorCuatrimestre : '',
          fichero : {
            ficheroB64 : '',
            extension_adjunto : ''
          }
        },
        formatosPermitidos : ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/pdf','application/msword','image/*'],
        clicked : false
      }
    },
    computed:{
      ...mapGetters({
        styles : 'getStyles',
        dominios : 'getDominios',
        brand : 'getBrand'
      }),
    },
    methods : {
      ...mapActions(['cambiaEstadoPractica']),
      handleFileUpload(event){
        
        this.$validator.validate('file')
        .then(itsOk => {
          console.log(itsOk);
          if(itsOk){

          let file = event.target.files[0];


          this.nombreArchivo = file.name;

          this.data.fichero.extension_adjunto = file.type.split("/")[1];

          this.getBase64(file).then(data => {
            this.data.fichero.ficheroB64 = data;
          });
        }

      });
     },
     getBase64: function(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    cerrar : function(){
      this.$emit('cerrar');
    },
    finalizar : function(){
      this.clicked = true;
      this.$validator.validateAll().then(itsOk => {
        if(itsOk){
          this.loading = true;
          this.cambiaEstadoPractica(this.data).then(r => {
            this.loading = false;
            if(r){
              this.cerrar();
            }else{
              this.loading = false;
            }
          }).catch(e =>{
            this.loading = false;
          });
        }
      });
    },
    setData : function(){
      this.data.idPractica = Number(this.$route.params.id);
      if(this.config.action == 'validar'){
        this.data.idEstado = 2;
      }else{
        this.data.idEstado = 3;
      }
    }
  }

}
</script>

<style scoped lang="scss">
  .popup-observaciones {
  	width: 100%;
  	position: fixed;
  	bottom: 0;
  	left: 0;
    top: 0;
    right: 0;
    height:auto;
    background: rgba(0,0,0,.9);
    padding: 50px 15px;
    z-index: 20;
  }

  .contenedor-popup-observaciones{
    padding: 50px;
    position: relative;
    max-width: 700px;
  }

  .contenedor-input{
    margin-top: 20px;
    padding-bottom: 0;
  }
  
  textarea{
    padding: 10px;
  }

  p{
    text-align: left;
    font-size: 14px;
    display: inline-block;
    margin-bottom: 20px;
    width: 100%;
    display: inline-block;
    line-height: 18px;
    
    strong{
      font-weight: 800;
    }

  }

  .dropzone{
    width: 100%;
    min-height: 50px;
    background: #f2f2f2;
    padding: 20px;
    position: relative;
  }

  .dropzone svg{
    width: 30px;
    height: 30px;
    filter: grayscale(1);
    opacity: .5
  }

  .dropzone input{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }

  .dropzone .text{
    width: 100%;
  }

  .dropzone p{
    text-align: center;
    font-size: 14px;
    color: #333;
    margin-left: 20px;
    margin-bottom: 0;
    width: auto;
  }

  .dropzone span.error{
    bottom: -24px;
  }

  label{
    margin-bottom: 10px;
  }

  .contenedor-input.-select p{
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/parts/popup-observaciones.vue